export default "Lav jeres egne simple og flotte amuletter af træskiver med fodspor fra dyr.";